/* components/FormattedCode.svelte generated by Svelte v3.44.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

import { sourceQuery } from '../stores.js';
import { debounce } from '../utils.js';
import { parse, print } from 'graphql';

function create_else_block(ctx) {
	let div;
	let span;
	let t_value = (/*error*/ ctx[3] || IS_LOADING_MESSAGE) + "";
	let t;

	return {
		c() {
			div = element("div");
			span = element("span");
			t = text(t_value);
			attr(span, "class", "svelte-1lrryiy");
			attr(div, "class", "message svelte-1lrryiy");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, span);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*error*/ 8 && t_value !== (t_value = (/*error*/ ctx[3] || IS_LOADING_MESSAGE) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (83:0) {#if !isLoading && !error && code}
function create_if_block(ctx) {
	let div;
	let pre;
	let t;
	let if_block = /*variables*/ ctx[1] && create_if_block_1(ctx);

	return {
		c() {
			div = element("div");
			pre = element("pre");
			t = space();
			if (if_block) if_block.c();
			attr(pre, "class", "code svelte-1lrryiy");
			attr(div, "class", "content svelte-1lrryiy");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, pre);
			pre.innerHTML = /*code*/ ctx[0];
			append(div, t);
			if (if_block) if_block.m(div, null);
		},
		p(ctx, dirty) {
			if (dirty & /*code*/ 1) pre.innerHTML = /*code*/ ctx[0];;

			if (/*variables*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

// (88:4) {#if variables}
function create_if_block_1(ctx) {
	let pre;

	return {
		c() {
			pre = element("pre");
			attr(pre, "class", "variables svelte-1lrryiy");
		},
		m(target, anchor) {
			insert(target, pre, anchor);
			pre.innerHTML = /*variables*/ ctx[1];
		},
		p(ctx, dirty) {
			if (dirty & /*variables*/ 2) pre.innerHTML = /*variables*/ ctx[1];;
		},
		d(detaching) {
			if (detaching) detach(pre);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (!/*isLoading*/ ctx[2] && !/*error*/ ctx[3] && /*code*/ ctx[0]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

const IS_LOADING_MESSAGE = 'Loading...';

function instance($$self, $$props, $$invalidate) {
	let code = ' ';
	let variables = null;
	let isLoading = false;
	let error = null;

	const debouncedUpdate = debounce(
		value => {
			if (value) {
				try {
					const normalizedString = value.replace(/(\r\n|\n|\r)/gm, "");
					const parsedString = JSON.parse(normalizedString);
					const isVariablesExists = !!Object.keys(parsedString.variables).length;
					$$invalidate(0, code = print(parse(parsedString.query)));

					if (isVariablesExists) {
						$$invalidate(1, variables = JSON.stringify(parsedString.variables, null, 2));
					} else {
						$$invalidate(1, variables = null);
					}
				} catch(e) {
					console.log(e);
					$$invalidate(3, error = 'Can\'t parce input :(');
				} finally {
					$$invalidate(2, isLoading = false);
				}
			}
		},
		500
	);

	sourceQuery.subscribe(value => {
		if (value) {
			$$invalidate(3, error = null);
			$$invalidate(2, isLoading = true);
		}

		debouncedUpdate(value);
	});

	return [code, variables, isLoading, error];
}

class FormattedCode extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default FormattedCode;